import { getProjectImageUrl, getPublicImageUrl } from '../../util/asset';

export function getDefaultTags() {
  const tags = [ 
    {
      name: 'C++',
      icon: getPublicImageUrl('cplus.svg'),
      checked: false,
      isInFilter: true,
      key: 'cplus',
    }, 
    {
      name: 'C#',
      icon: getPublicImageUrl('csharp.svg'),
      checked: false,
      isInFilter: true,
      key: 'csharp',
    }, 
    {
      name: 'JavaScript',
      icon: getPublicImageUrl('js.svg'),
      checked: false,
      isInFilter: true,
      key: 'js',
    }, 
    {
      name: 'ReactJS',
      icon: getPublicImageUrl('react.svg'),
      checked: false,
      isInFilter: true,
      key: 'reactjs',
    }, 
    {
      name: 'Phaser',
      icon: getPublicImageUrl('phaser.png'),
      checked: false,
      isInFilter: true,
      key: 'phaser',
    },
    {
      name: 'Python',
      icon: getPublicImageUrl('python.svg'),
      checked: false,
      isInFilter: true,
      key: 'python',
    },
    {
      name: 'PHP',
      icon: getPublicImageUrl('php.svg'),
      checked: false,
      isInFilter: true,
      key: 'php',
    },
    {
      name: 'Flask',
      icon: getPublicImageUrl('flask.svg'),
      checked: false,
      isInFilter: true,
      key: 'flask',
    },
    {
      name: 'Java',
      icon: getPublicImageUrl('java.svg'),
      checked: false,
      isInFilter: true,
      key: 'java',
    },
    {
      name: 'Hadoop',
      icon: getPublicImageUrl('hadoop.svg'),
      checked: false,
      isInFilter: true,
      key: 'hadoop',
    },
    {
      name: 'Unity',
      icon: getPublicImageUrl('unity.svg'),
      checked: false,
      isInFilter: true,
      key: 'unity',
    },
    {
      name: 'Laravel',
      icon: getPublicImageUrl('laravel.svg'),
      checked: false,
      isInFilter: true,
      key: 'laravel',
    },
    {
      name: 'Vue.js',
      icon: getPublicImageUrl('vue.svg'),
      checked: false,
      isInFilter: true,
      key: 'vue',
    },
    {
      name: 'BabylonJS',
      icon: getPublicImageUrl('babylonjs.svg'),
      checked: false,
      isInFilter: true,
      key: 'babylonjs',
    },
    {
      name: 'Egret Engine',
      icon: getPublicImageUrl('egret.webp'),
      checked: false,
      isInFilter: true,
      key: 'egret',
    },
    {
      name: 'Cocos Creator',
      icon: getPublicImageUrl('cocos_creator.png'),
      checked: false,
      isInFilter: true,
      key: 'cocos_creator',
    }
  ];
  // Sort based on alphabetical order
  tags.sort(function (a, b) {
    return (a.name < b.name) ? -1 : 1;
  });
  return tags;
}

export function getAllTag() {
  return {
    name: 'All',
    icon: '',
    checked: true,
    isInFilter: true,
  };
}

export function getDummyProjects() {
  const projects = [
    {
      icon: getProjectImageUrl('placeholder.gif'),
      title: 'Project Title A',
      description: 'Project Description',
      demo: 'https://miscavel.gitlab.io/home',
      repo: 'https://gitlab.com/Miscavel/home',
      tagList: [ 'cplus', 'csharp', 'js', 'reactjs', 'phaser' ],
      isInFilter: true,
      date: 6,
    },
    {
      icon: getProjectImageUrl('placeholder.gif'),
      title: 'Project Title B',
      description: 'Project Description',
      demo: 'https://miscavel.gitlab.io/home',
      repo: 'https://gitlab.com/Miscavel/home',
      tagList: [ 'cplus' ],
      isInFilter: true,
      date: 5,
    },
    {
      icon: getProjectImageUrl('placeholder.gif'),
      title: 'Project Title C',
      description: 'Project Description',
      demo: 'https://miscavel.gitlab.io/home',
      repo: 'https://gitlab.com/Miscavel/home',
      tagList: [ 'csharp' ],
      isInFilter: true,
      date: 4,
    },
    {
      icon: getProjectImageUrl('placeholder.gif'),
      title: 'Project Title D',
      description: 'Project Description',
      demo: 'https://miscavel.gitlab.io/home',
      repo: 'https://gitlab.com/Miscavel/home',
      tagList: [ 'js' ],
      isInFilter: true,
      date: 3,
    },
    {
      icon: getProjectImageUrl('placeholder.gif'),
      title: 'Project Title E',
      description: 'Project Description',
      demo: 'https://miscavel.gitlab.io/home',
      repo: 'https://gitlab.com/Miscavel/home',
      tagList: [ 'reactjs' ],
      isInFilter: true,
      date: 2,
    },
    {
      icon: getProjectImageUrl('placeholder.gif'),
      title: 'Project Title F',
      description: 'Project Description',
      demo: 'https://miscavel.gitlab.io/home',
      repo: 'https://gitlab.com/Miscavel/home',
      tagList: [ 'phaser' ],
      isInFilter: true,
      date: 1,
    }
  ];
  return projects;
}

export function getDefaultProjects() {
  const projects = [
    {
      icon: getProjectImageUrl('sand_collector.png'),
      title: 'Sand Collector',
      description: '2D platformer puzzle game inspired by Lode Runner',
      repo: 'https://gitlab.com/Miscavel/sand-collector-game-sfml',
      tagList: [ 'cplus' ],
      isInFilter: true,
      date: 1500466595,
    },
    {
      icon: getProjectImageUrl('collapse.png'),
      title: 'Collapse',
      description: '2D colored tile-matching puzzle game',
      repo: 'https://gitlab.com/Miscavel/collapse-game-sfml',
      tagList: [ 'cplus' ],
      isInFilter: true,
      date: 1497874595,
    },
    {
      icon: getProjectImageUrl('sokoban.png'),
      title: 'Sokoban',
      description: '2D boulder-pushing puzzle game inspired by the original Sokoban',
      repo: 'https://gitlab.com/Miscavel/sokoban-game-sfml',
      tagList: [ 'cplus' ],
      isInFilter: true,
      date: 1487506595,
    },
    {
      icon: getProjectImageUrl('poring_puzzle.png'),
      title: 'Poring Puzzle',
      description: '2D poring-matching puzzle game, inspired by the mechanics in Collapse combined with an additional twist of gravity mechanics',
      repo: 'https://gitlab.com/Miscavel/poring-puzzle-game-sfml',
      tagList: [ 'cplus' ],
      isInFilter: true,
      date: 1498392995,
    },
    {
      icon: getProjectImageUrl('legend_of_xolda.png'),
      title: 'Legend of Xolda',
      description: '2D top-down hack and slash game, an attempt in combining the mechanics and design of Ragnarok Online and Legend of Zelda',
      repo: 'https://gitlab.com/Miscavel/legend-of-xolda-game-sfml',
      tagList: [ 'cplus' ],
      isInFilter: true,
      date: 1503663395,
    },
    {
      icon: getProjectImageUrl('bomberman.png'),
      title: 'Bomberman (LAN)',
      description: '2D multiplayer bomberman game written in Python',
      repo: 'https://gitlab.com/Miscavel/bomberman-lan-python',
      tagList: [ 'python' ],
      isInFilter: true,
      date: 1535199395,
    },
    {
      icon: getProjectImageUrl('opengl_2.png'),
      title: 'OpenGL 2.0',
      description: '3D simulation with gouraud shading written in OpenGL 2.0',
      repo: 'https://gitlab.com/Miscavel/opengl',
      tagList: [ 'cplus' ],
      isInFilter: true,
      date: 1537877795,
    },
    {
      icon: getProjectImageUrl('image_filter.png'),
      title: 'Image Filter',
      description: 'Application to apply various filters to uploaded image written in C#',
      repo: 'https://gitlab.com/Miscavel/image-processing-csharp',
      tagList: [ 'csharp' ],
      isInFilter: true,
      date: 1540469795,
    },
    {
      icon: getProjectImageUrl('flap_flap_dragon.png'),
      title: 'Flap Flap Dragon',
      description: 'Flappy Bird-esque endless runner, made as part of an internship program at Alkemis Games Studio',
      demo: 'https://miscavel.gitlab.io/html5/game/alkemis/flap-flap-dragon/index.html',
      tagList: [ 'js', 'phaser' ],
      isInFilter: true,
      date: 1545740195,
    },
    {
      icon: getProjectImageUrl('jump_boo.png'),
      title: 'Jump Boo',
      description: 'Doodle Jump-esque endless runner, made as part of an internship program at Alkemis Games Studio',
      demo: 'https://miscavel.gitlab.io/html5/game/alkemis/jump-boo/index.html',
      tagList: [ 'js', 'phaser' ],
      isInFilter: true,
      date: 1551096995,
    },
    {
      icon: getProjectImageUrl('a_part_man.png'),
      title: 'A-Part Man',
      description: 'Whac A Mole-esque arcade game, made as part of an internship program at Alkemis Games Studio',
      demo: 'https://miscavel.gitlab.io/html5/game/alkemis/apart-man/index.html',
      tagList: [ 'js', 'phaser' ],
      isInFilter: true,
      date: 1553516195,
    },
    {
      icon: getProjectImageUrl('cat_r_cher.png'),
      title: `Cat R'cher`,
      description: '2D projectile shooting game inspired by Santa Basketball, made as part of an internship program at Alkemis Games Studio',
      demo: 'https://miscavel.gitlab.io/html5/game/alkemis/cat-archer/index.html',
      tagList: [ 'js', 'phaser' ],
      isInFilter: true,
      date: 1561464995,
    },
    {
      icon: getProjectImageUrl('iris_classifier.png'),
      title: 'Iris Classifier',
      description: 'Application to classify Iris flowers based on their characteristics using DBSCAN and Naive Bayes classifier',
      repo: 'https://gitlab.com/Miscavel/iris-prediction',
      tagList: [ 'cplus' ],
      isInFilter: true,
      date: 1564056995,
    },
    {
      icon: getProjectImageUrl('heart_disease_prediction.png'),
      title: 'Heart Disease Prediction',
      description: 'Application to predict whether a patient has a heart disease based on his / her condition using K-Nearest Neighbor',
      repo: 'https://gitlab.com/Miscavel/heart-disease-prediction',
      tagList: [ 'cplus' ],
      isInFilter: true,
      date: 1566735395,
    },
    {
      icon: getProjectImageUrl('opengl_3.png'),
      title: 'OpenGL 3.0',
      description: '3D simulation with gouraud shading written in OpenGL 3.0',
      repo: 'https://gitlab.com/Miscavel/opengl-3.0',
      tagList: [ 'cplus' ],
      isInFilter: true,
      date: 1566994595,
    },
    {
      icon: getProjectImageUrl('vmware_controller.png'),
      title: 'VMWare Remote Controller',
      description: 'Application to control VMWare instances remotely from a web-app using VMWare API and noVNC',
      repo: 'https://gitlab.com/Miscavel/vmware-remote-controller',
      tagList: [ 'cplus', 'js', 'php' ],
      isInFilter: true,
      date: 1569672995,
    },
    {
      icon: getProjectImageUrl('jewelry_matcher.jpg'),
      title: 'Jewelry Matcher',
      description: 'Application to find matching jewelries and rank them based on similarities',
      repo: 'https://gitlab.com/Miscavel/jewelry-matcher-python',
      tagList: [ 'python', 'flask' ],
      isInFilter: true,
      date: 1572264995,
    },
    {
      icon: getProjectImageUrl('trivago.png'),
      title: 'Trivago Recommender System',
      description: 'Application to find recommended hotels for users based on their search history, made as part of an undergraduate thesis at Petra Christian University',
      repo: 'https://gitlab.com/Miscavel/trivago-graph-analysis',
      tagList: [ 'java', 'hadoop' ],
      isInFilter: true,
      date: 1580213795,
    },
    {
      icon: getProjectImageUrl('fire_emblem_heroes.png'),
      title: 'Fire Emblem Heroes',
      description: 'An attempt to make a Fire Emblem Heroes clone in Unity as part of a university project',
      demo: 'https://miscavel.gitlab.io/fire-emblem-heroes-unity/',
      repo: 'https://gitlab.com/Miscavel/fire-emblem-heroes-unity',
      tagList: [ 'csharp', 'unity' ],
      isInFilter: true,
      date: 1582892195,
    },
    {
      icon: getProjectImageUrl('laravel_library.png'),
      title: 'Laravel Library',
      description: 'A web-app where users can register and search for authors and books',
      demo: 'https://laravel-yaraku.herokuapp.com/',
      repo: 'https://gitlab.com/Miscavel/laravel-yaraku',
      tagList: [ 'laravel', 'php', 'vue' ],
      isInFilter: true,
      date: 1585397795,
    },
    {
      icon: getProjectImageUrl('infinite_runner.png'),
      title: 'Infinite Runner',
      description: 'Google Dinosaur-esque endless runner',
      demo: 'https://miscavel.gitlab.io/html5/game/shopee/infinite-runner',
      repo: 'https://gitlab.com/Miscavel/infinite-runner',
      tagList: [ 'js', 'phaser' ],
      isInFilter: true,
      date: 1588076195,
    },
    {
      icon: getProjectImageUrl('puzzle_bobble.png'),
      title: 'Puzzle Bobble',
      description: 'A bubble-shooting match-3 puzzle game inspired by Bubble Bobble',
      demo: 'https://miscavel.gitlab.io/html5/game/shopee/puzzle-bobble/',
      repo: 'https://gitlab.com/Miscavel/puzzle-bobble',
      tagList: [ 'js', 'phaser' ],
      isInFilter: true,
      date: 1588076196,
    },
    {
      icon: getProjectImageUrl('helix_jump.png'),
      title: 'Helix Jump',
      description: '3D arcade bouncing ball game prototype inspired by the original Helix Jump',
      demo: 'https://miscavel.gitlab.io/helix-jump/',
      repo: 'https://gitlab.com/Miscavel/helix-jump',
      tagList: [ 'js', 'babylonjs', 'reactjs' ],
      isInFilter: true,
      date: 1588076197,
    },
    {
      icon: getProjectImageUrl('puzzle_bobble_egret.png'),
      title: 'Puzzle Bobble Egret',
      description: 'Puzzle Bobble re-written in Egret framework with additional polish',
      demo: 'https://miscavel.gitlab.io/puzzle-bobble-egret/',
      repo: 'https://gitlab.com/Miscavel/puzzle-bobble-egret',
      tagList: [ 'js', 'egret' ],
      isInFilter: true,
      date: 1611836195,
    },
    {
      icon: getProjectImageUrl('cocos_mbn6.png'),
      title: 'Cocos MBN 6',
      description: 'A demo of Megaman Battle Network 6 battle system clone as part of Cocos Creator research',
      demo: 'https://miscavel.gitlab.io/cocos-mbn/',
      repo: 'https://gitlab.com/Miscavel/cocos-mbn',
      tagList: [ 'js', 'cocos_creator' ],
      isInFilter: true,
      date: 1611836196,
    },
    {
      icon: getProjectImageUrl('cocos_snake.png'),
      title: 'Cocos Snake',
      description: 'Classic snake game made as part of teaching materials to onboard engineers to Cocos Creator',
      demo: 'https://miscavel.gitlab.io/cocos-snake/',
      repo: 'https://gitlab.com/Miscavel/cocos-snake',
      tagList: [ 'js', 'cocos_creator' ],
      isInFilter: true,
      date: 1611836197,
    },
    {
      icon: getProjectImageUrl('stack_block.png'),
      title: 'Stack Block',
      description: '3D casual game where players are expected to build the highest tower possible by stacking blocks on top of each other',
      demo: 'https://miscavel.gitlab.io/stack-block/',
      repo: 'https://gitlab.com/Miscavel/stack-block',
      tagList: [ 'js', 'cocos_creator' ],
      isInFilter: true,
      date: 1611836198,
    },
    {
      icon: getProjectImageUrl('component_editor.png'),
      title: 'Component Editor',
      description: 'A demo of component editor where users can change the visual of the displayed button by editing the available options or inserting new parameters',
      demo: 'https://miscavel.gitlab.io/react-uxpin-ui/',
      repo: 'https://gitlab.com/Miscavel/react-uxpin-ui',
      tagList: [ 'js', 'reactjs' ],
      isInFilter: true,
      date: 1643372195,
    },
    {
      icon: getProjectImageUrl('idle_quest.png'),
      title: 'Idle Quest',
      description: 'Online coding test (JavaScript) combined with an idle game',
      demo: 'https://miscavel.gitlab.io/online-editor',
      repo: 'https://gitlab.com/Miscavel/online-editor',
      tagList: [ 'js', 'reactjs', 'phaser' ],
      isInFilter: true,
      date: 1643372196,
    },
    {
      icon: getProjectImageUrl('wander_island.png'),
      title: 'Wander Island',
      description: '2D top-down RPG inspired by the Legend of Zelda, made for the finals of a rally game where the participants would race to finish the game within the shortest time possible',
      demo: 'https://miscavel.itch.io/wander-island',
      tagList: [ 'csharp', 'unity' ],
      isInFilter: true,
      date: 1534162595,
    },
    {
      icon: getProjectImageUrl('big_iron.png'),
      title: 'Big Iron',
      description: '2D top-down Zelda-esque RPG, with a twist of stamina and animation-cancel system inspired by Tekken and Dark Souls',
      demo: 'https://miscavel.itch.io/big-iron',
      tagList: [ 'csharp', 'unity' ],
      isInFilter: true,
      date: 1544703395,
    },
    {
      icon: getProjectImageUrl('last_fortress.png'),
      title: 'Last Fortress',
      description: '3D tower defense game inspired by Plant vs Zombie',
      demo: 'https://miscavel.itch.io/last-fortress',
      tagList: [ 'csharp', 'unity' ],
      isInFilter: true,
      date: 1576239395,
    },
    {
      icon: getProjectImageUrl('old_homepage.png'),
      title: 'Old Homepage',
      description: 'Old homepage for miscavel.gitlab.io',
      demo: 'https://miscavel.gitlab.io/old/',
      repo: 'https://gitlab.com/Miscavel/old',
      tagList: [ 'js' ],
      isInFilter: true,
      date: 1578917795,
    },
    {
      icon: getProjectImageUrl('reddit_browser.png'),
      title: 'Reddit Browser',
      description: 'A custom browser for reddit posts to bypass the 200 page limit using https://github.com/pushshift/api',
      demo: 'https://miscavel.gitlab.io/reddit-browser',
      repo: 'https://gitlab.com/Miscavel/reddit-browser',
      tagList: [ 'js', 'reactjs' ],
      isInFilter: true,
      date: 1643372197,
    },
    {
      icon: getProjectImageUrl('temperature_converter.png'),
      title: 'Temperature Converter',
      description: 'An application to convert temperatures between Celsius, Fahrenheit, Kelvin, Rankine, and Reaumur',
      demo: 'https://miscavel.gitlab.io/temperature-converter',
      repo: 'https://gitlab.com/Miscavel/temperature-converter',
      tagList: [ 'js', 'reactjs' ],
      isInFilter: true,
      date: 1643372198,
    },
    {
      icon: getProjectImageUrl('kana_training.jpg'),
      title: 'Kana Training',
      description: 'An app for training hiragana, katakana, and kanjis (inspired by https://hiragana.training/)',
      demo: 'https://miscavel.gitlab.io/kana-training',
      repo: 'https://gitlab.com/Miscavel/kana-training',
      tagList: [ 'js', 'reactjs' ],
      isInFilter: true,
      date: 1643372199,
    },
  ];
  return projects.sort(function(a, b) {
    return b.date - a.date;
  });
}